<template>
	<div class="order-details-box">
		<header class="lmy-header lmy-header-w">
			<i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
	        订单详情
	  </header>
		<div class="infinite-loading-containers" style="margin-top:1.2rem" v-if="isLoading">
			<i class="loading-defaults"></i>
		</div>
		<div class="top" v-if="!isLoading">
      <div class="txt" v-if="bookInfo.Status == 0">
        <p class="order-type">无效订单</p>
        <!-- <p>无效订单</p> -->
      </div>
      <div class="txt" v-if="bookInfo.Status == 2">
        <p class="order-type">订单已锁定</p>
      </div>
      <div class="txt" v-if="bookInfo.Status == 9">
        <p class="order-type">新订单</p>
      </div>
      <div class="txt" v-if="bookInfo.Status == 8">
        <p class="order-type">订单已取消</p>
      </div>
      <div class="txt" v-if="bookInfo.Status == 10">
        <p class="order-type">订单已确认</p>
      </div>
      <div class="txt" v-if="bookInfo.Status == 27">
        <p class="order-type">订单可入住</p>
      </div>
      <div class="txt" v-if="bookInfo.Status == 28">
        <p class="order-type">订单已入住</p>
      </div>
			<div class="txt" v-if="bookInfo.Status == 29" >
        <p class="order-type">订单已离店</p>
      </div>
      <div class="txt" v-if="bookInfo.Status == 30" >
        <p class="order-type">订单罚金取消</p>
      </div>
    </div>


  	<div class="middle" v-if="!isLoading">
			<div class="order-price flow">
				<p>总计：<span class="sym">￥</span><span class="num">{{bookInfo.TotalAmount}}</span></p>
			</div>
		</div>
		<div class="bottom" v-if="!isLoading">
            <div class="details">
                <p class="title">订单信息</p>
                <ul>
                    <li>
                        <span class="lable">订单号：</span>
                        <span>{{QGOrderNO}}</span>
                    </li>
                    <li>
                        <span class="lable">预约码：</span>
                        <span>{{Code}}</span>
                    </li>
                    <li>
                        <span class="lable">产品名称：</span>
                        <span>{{bookInfo.HotelName}}</span>
                    </li>
                    <li>
                        <span class="lable">产品类型：</span>
                        <span>{{bookInfo.RoomName}} ({{bookInfo.RoomCount}}间)</span>
                    </li>
										<li>
                        <span class="lable">产品政策：</span>
                        <span>{{bookInfo.RPName||'无'}}</span>
                    </li>
                    <li> 
                        <span class="lable">入离时间：</span>
                        <span>{{bookInfo.CheckInStr|dateToYMDline}} 到 {{bookInfo.CheckOutStr|dateToYMDline}}</span>
                    </li>
                    <li>
                        <span class="lable">特殊要求：</span>
                        <span>{{bookInfo.Remark||'无'}}</span>
                    </li>
										<li>
                        <span class="lable">取消条款：</span>
                        <span>{{bookInfo.CancelPolicy||'无'}}</span>
                    </li><li>
                        <span class="lable">下单时间：</span>
                        <span>{{bookInfo.BookingOn|dateLong}}</span>
                    </li>
                </ul>
            </div>
    </div>
			<div class="bottom" v-if="!isLoading">
							<div class="details">
									<p class="title">住客信息</p>
									<ul v-for="(user,index) in bookInfo.Guest" :key="index">
											<li>
													<span class="lable">入住人{{index+1}}：</span>
													<span>{{user.FirstName}}{{user.LastName}}</span>
											</li>
											<li>
													<span class="lable">联系电话：</span>
													<span>{{user.Phone||'无'}}</span>
											</li>
									</ul>
							</div>
			</div>
			<div class="bottom" v-if="!isLoading">
            <div class="details">
                <p class="title">酒店信息</p>
                <ul>
                    <li>
                        <span class="lable">酒店地址：</span>
                        <span>{{bookInfo.HotelAddress||'无'}}</span>
                    </li>
                    <li>
                        <span class="lable">酒店电话：</span>
                        <span>{{bookInfo.HotelPhone||'无'}}</span>
                    </li>
                </ul>
            </div>
    	</div>
	</div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  name: "bookDetails",
  components: {
  },
  data() {
    return {
      bookInfo: {},
      isLoading: true, //是否显示loading
      OrderNO: "",
      QGOrderNO:'',
      Code:'',
    };
  },
  methods: {
    copyOrderNumber() {
      var clipboard = new Clipboard(".copyOrderNumber");
      var that = this;
      clipboard.on("success", e => {
        that.$alert("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        that.$alert("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getOrderDetails() {
      var that = this;
      var param = {
        orderNO: that.OrderNO
      };
      that
        .getRequest({
          url: that.Api.getOrderDetails,
          params: param
        })
        .then(res => {
          that.isLoading = false;
          if (res && res.IsSuccess) {
            var Result = res.Result;
            that.bookInfo = res.Result;
          } else {
            that.$router.push("/");
          }
        });
    }
  },
  mounted() {
    this.OrderNO = this.$route.query.OrderNO;
    this.QGOrderNO = this.$route.query.QGOrderNo;
    this.Code = this.$route.query.Code;
    this.getOrderDetails();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/book/reserve/bookDetails.vue